<template>
  <mdb-container class="gp-has-header">

    <mdb-card v-if="!token" class="text-left">
      <mdb-card-header>
        <h3>Error</h3>
      </mdb-card-header>
      <mdb-card-body>
        Invalid invitation link.
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="token && inviteDetails" class="text-left">
      <mdb-card-header>
        <avatar :avatar="inviteDetails.groupAvatar" :size="200"/>
        <h3>Invitation to join {{ inviteDetails.groupName }}</h3>
      </mdb-card-header>
      <mdb-card-body v-if="loggedIn">
        <div>
          Do you want to accept the invitation to {{inviteDetails.groupName}}?
        </div>
        <div>
          <mdb-btn icon="hand" @click="accept">Accept Invitation</mdb-btn>
        </div>
        <div class="text-info" v-if="userDetails.email != inviteDetails.email">
          Note: This invite was sent to <b>{{inviteDetails.email}}</b>, which is different from your
          account email address, {{userDetails.email}}. This is not a problem, but if you accept the
          invitation, your membership will be tied to your current account email and not the one the invite was
          sent to.  You may also change your account email address at any time.
        </div>
      </mdb-card-body>
      <mdb-card-body v-if="!loggedIn">
        <div>
          Invitation sent to <b>{{inviteDetails.email}}</b>.
        </div>
        <div>
          <mdb-btn icon="hand" @click="accept">Create Account and Accept</mdb-btn>
        </div>
        <div class="text-info">
          <p>If you already have an account, please <router-link to="/login">login</router-link> first. Then follow your invitation
            link back to here to accept the invitation.</p>
          <p>If you wish to login using your Facebook or Google accounts, please use <router-link to="/register">this link</router-link>
            first. Then follow your invitation link back here.</p>
        </div>
      </mdb-card-body>

    </mdb-card>

    <mdb-modal class="text-left" size="lg" v-if="showCreateModal" @close="showCreateModal=false">
      <mdb-modal-header :close="true" class="primary-color text-center text-white">
        <h5>Create Account</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input icon="id-card-alt" label="Name" required small="Your name as others will see it."
                   type="text" name="name"
                   v-model="newAccount.name"/>
        <mdb-input icon="envelope" label="E-mail Address" required name="email"
                   small="This not shared with members or organizers." type="text"
                   v-model="newAccount.email"/>
        <mdb-input icon="lock" label="Password" required type="password" v-model="newAccount.password" name="password"/>
        <mdb-input icon="lock" label="Re-type Password" required type="password" name="passwordConfirm"
                   v-model="newAccount.passwordConfirm"/>
        <div class="form-check">
          <input class="form-control form-check-input" id="tosAgree" type="checkbox"
                 v-model="newAccount.tosAgree"/>
          <label for="tosAgree">I agree to the Terms of Service</label>
          <div>
            <a @click.prevent="$router.push('/page/tos')" href="">Terms of Service</a>
            &nbsp; &bull; &nbsp;
            <a @click.prevent="$router.push('/page/privacy')" href="">Privacy Policy</a>
          </div>

        </div>
        <mdb-btn @click="acceptSubmit" :disabled="!formIsValid" type="submit">Submit</mdb-btn>

      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>

</template>
<script>
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import YesNoModal from "../common/YesNoModal";
import api from '../../services/groupsPlaceApi.js'
import Avatar from "../common/Avatar";

export default {
  name: "invitation-accept",
  order: 1,
  components: {
    mdbContainer,
    mdbTbl, mdbTblHead, mdbTblBody, mdbBtn, mdbInput, mdbCard, mdbCardHeader, mdbCardBody, mdbCardFooter,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    YesNoModal,
    Avatar
  },
  data() {
    return {
      token: null,
      inviteDetails: null,
      newAccount: { password: "", passwordConfirm: "", name: "", email: "", tosAgree: false},
      showCreateModal: false
    }
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    apiKey() {
      return this.$store.state.apiKey
    },
    loggedIn() {
      return this.$store.state.loggedIn
    },
    formIsValid() {
      if (this.newAccount.password != this.newAccount.passwordConfirm) return false
      if (!this.newAccount.tosAgree) return false
      if (!this.newAccount.email) return false
      if (!this.newAccount.name) return false
      if (!this.newAccount.password) return false
      return true

    }
  },
  mounted() {
    document.title = "Accept Invitation"
    this.token = this.$route.query.token
    if (!this.token) {
      return
    }
    this.$store.dispatch("setExecuting", true)
    api.post("/member/validateInvite", {token: this.token}).then(
      (results) => {
        this.inviteDetails = results.data
        this.newAccount.name = results.data.email.split("@")[0]
        this.newAccount.email = results.data.email
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 20000})
        this.$router.push("/")
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })

  },
  methods: {
    accept() {
      if (this.userDetails && this.userDetails.email) {
        this.acceptSubmit()
        return
      }

      this.showCreateModal = true

    },
    acceptSubmit() {
      this.showCreateModal = false
      this.newAccount.token = this.token
      this.$store.dispatch("setExecuting", true)
      api.post("/member/acceptInvite", this.newAccount).then(
        (results) => {
          if (!this.loggedIn) {
            localStorage.setItem("apiKey", results.data.authKey)
            localStorage.setItem("secret", results.data.secret)
            this.$store.dispatch("setApiKey", results.data.authKey)
            this.$store.dispatch("setSecret", results.data.secret)
            this.$store.dispatch("setLoggedIn", true)
          }
          //Force reload store, etc.
          window.location = this.inviteDetails.groupUrl
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }

  }
};

</script>

